const steps = [
  {
    icon: "ri-chat-3-line",
    title: "逛热榜 · 刷热评",
    desc: "进入实时热榜看各路网友犀利热评与爆料补充，最新话题随时开聊，节奏快但绝不冷场。",
  },
  {
    icon: "ri-group-line",
    title: "找同好 · 对暗号",
    desc: "晒出你追的剧、听的歌或嗑的 CP 附上暗号，群聊里同好秒上线，组队追更蹲后续不再孤单。",
  },
  {
    icon: "ri-message-2-line",
    title: "树洞倾诉 · 蹲后续",
    desc: "想匿名说心里话就进深夜树洞，想蹲剧情进展就回板块等更新，一整天的情绪都有处安放。",
  },
];

export default function PlaySection() {
  return (
    <section id="play" className="bg-background-950 py-16 text-background-50 md:py-20">
      <div className="container-site grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-secondary-400">
            How to Play
          </span>
          <h2 className="mt-2 text-2xl font-black md:text-4xl">三步玩转瓜田 · 气氛组已就位</h2>
          <p className="mt-3 text-sm leading-relaxed text-background-100/90 md:text-base">
            这里没有看不懂的门槛，只有聊不完的话题。无论你是安静吃瓜派还是冲浪段子手，都能快速找到自己的位置，互动氛围拉满。
          </p>

          <div className="mt-8 flex flex-col gap-4">
            {steps.map((s, i) => (
              <div
                key={i}
                className="flex items-start gap-4 rounded-xl border border-background-50/10 bg-background-50/[0.06] p-4"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-display text-secondary-400">0{i + 1}</span>
                    <h3 className="text-base font-bold">{s.title}</h3>
                  </div>
                  <p className="mt-1 text-sm leading-relaxed text-background-100/90">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=energetic%20young%20friends%20sitting%20together%20laughing%20and%20chatting%20on%20their%20phones%2C%20watermelon%20snacks%20and%20soda%20on%20table%2C%20cozy%20indoor%20community%20hangout%20at%20night%2C%20warm%20cinematic%20lighting%2C%20modern%20casual%20style%2C%20vibrant%20red%20and%20green%20color%20accents&width=900&height=1000&seq=play-collage-2026&orientation=portrait"
            alt="瓜友围坐一起刷手机热聊吃瓜的氛围场景"
            title="国产吃瓜社区找同好组队追更"
            className="h-[420px] w-full rounded-2xl object-cover md:h-[520px]"
          />
          <div className="absolute -left-3 bottom-6 flex items-center gap-3 rounded-xl bg-background-50 p-3 shadow-lift md:-left-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <div>
              <p className="text-sm font-bold text-foreground-950">今日 8 话题上热榜</p>
              <p className="text-xs text-foreground-600">瓜友实时热评中</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}